import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {
  transform(value: number): string {
    const stringValue = value.toString();
    const countryCode = stringValue.substring(0, 3);
    const areaCode = stringValue.substring(3, 6);
    const firstPart = stringValue.substring(6, 8);
    const secondPart = stringValue.substring(8, 10);

    return `(${countryCode}) ${areaCode}-${firstPart}-${secondPart}`;
  }
}
